'use client';

import { Container, styled, Typography } from '@mui/material';

const HeroBanner = styled('div')(({ theme }) => ({
  margin: '-32px auto 0',
  backgroundImage: `url(${process.env.NEXT_PUBLIC_IMGIX_HOSTNAME}/static/terms-banner.png?auto=format)`,
  backgroundPosition: 'right -250px center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  maxWidth: 1600,

  [theme.breakpoints.up('sm')]: {
    backgroundSize: 'contain',
    backgroundPosition: 'right center',
    marginTop: -64,
  },
}));

const HeroHeaderWrapper = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),

  '@media (min-width: 1000px)': {
    paddingTop: theme.spacing(16),
    paddingBottom: theme.spacing(16),
  },
}));

const HeroHeader = styled(Typography)({
  fontSize: 24,

  '@media (min-width: 700px)': {
    fontSize: 48,
  },
});

export default function TermsBanner() {
  return (
    <HeroBanner>
      <Container>
        <HeroHeaderWrapper>
          <HeroHeader variant="h1">Terms of Service</HeroHeader>
          <Typography mt={1} maxWidth={220}>
            Learn about your rights and responsibilities on Motivo
          </Typography>
        </HeroHeaderWrapper>
      </Container>
    </HeroBanner>
  );
}
